/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import Xml2js from 'xml2js';
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(VueAxios, axios);
Vue.use(Vuex);

//const api = 'http://localhost:4000/';
//const api = 'https://lehrstellen.smd-test.at/api/';
const api = 'https://industrielehre.kleinezeitung.at/api/';

interface RssResult {
  rss: any;
}

interface XmlResult {
  jobs: any;
}

interface FilterRequest {
  filter?: FilterRequestFilter;
  fulltext?: string;
}

interface FilterRequestFilter {
  branche?: string;
  bundesland?: string;
  bezirk?: string;
}

interface DataValue {
  id: number;
  name: string;
  bezirke?: Array<DataValue>;
  count?: number;
}

const set: Function = (key: any) => (state: any, val: any) => {
  state[key] = val;
};

const increment: Function = (key: any) => (state: any) => {
  state[key]++;
};

const decrement: Function = (key: any) => (state: any) => {
  state[key]--;
};

export default new Vuex.Store({
  state: {
    loading: 0,
    fulltext: '',
    ajaxbounce: null,
    newsitems: [],
    order: 1,
    imagedir: api,
    lehrstellen: [],
  },
  mutations: {
    startLoading: increment('loading'),
    finishLoading: decrement('loading'),
    setNewsitems: set('newsitems'),
    setLehrstellen: set('lehrstellen'),
    setUnternehmen: set('unternehmen'),
    setFulltext: set('fulltext'),
    setError: set('error'),
    setOrder: set('order'),
  },
  actions: {
    API(context, { url, data, method }) {
      const options: {} = { headers: {} };

      switch (method) {
        case 'get':
          return axios.get(api + url, options);
          break;
        case 'delete':
          return axios.delete(api + url, options);
          break;
        case 'post':
          return axios.post(api + url, data, options);
          break;
        case 'put':
          return axios.put(api + url, data, options);
          break;
        case 'patch':
          return axios.patch(api + url, data, options);
          break;
      }
    },

    loadLehrstelleById(context, id) {
      if (context.state.lehrstellen.length > 0) {
        return context.state.lehrstellen.find((stelle: any) => stelle.id == id);
      } else {
        return context.dispatch('loadLehrstellen').then(() => {
          return context.state.lehrstellen.find((stelle: any) => stelle.id == id);
        });
      }
    },

    loadLehrstellen(context) {
      context.commit('startLoading');
      const config: { url: string; data?: object; method: 'get' | 'post' } = { url: 'lehrstellen', method: 'get' };
      if (context.state.fulltext != '') {
        config.method = 'post';
        config.data = {
          filter: context.state.fulltext,
        };
      }
      return context
        .dispatch('API', config)
        .then((response: any) => {
          switch (context.state.order) {
            case 1: // Alphabethisch
              response.data.message.sort((a: any, b: any) => (a.title > b.title ? 1 : -1));
              break;
            default:
              response.data.message.shuffle();
              break;
          }
          context.commit('setLehrstellen', response.data.message);
          context.commit('finishLoading');
        })

        .catch((err: Error) => context.commit('setError', err));
    },

    loadUnternehmenById(context, id) {
      return context.dispatch('API', { method: 'get', url: 'unternehmen/' + id });
    },

    setOrder(context, order: number) {
      context.commit('setOrder', order);
      context.dispatch('loadLehrstellen');
    },
    clearFilters(context) {
      context.commit('setFulltext', '');
    },
    setFulltext(context, data: string) {
      context.commit('setFulltext', data);
      context.dispatch('loadLehrstellen');
    },

    loadRSS(context) {
      context.commit('startLoading');

      return axios
        .get('https://www.kleinezeitung.at/rss/industrielehre')
        .then((response: any) => {
          const items: Array<object> = [];
          Xml2js.parseString(response.data, function(err: Error, result: RssResult) {
            context.commit('finishLoading');
            let i = 0;
            Object.keys(result.rss.channel[0].item).forEach(function(key) {
              i++;

              if (i > 10) {
                return;
              }
              const item = result.rss.channel[0].item[key];
              if (item.enclosure && item.link && item.title) {
                items.push({
                  id: key,
                  image: item.enclosure[0].$.url,
                  url: item.link,
                  //headline: item.category[0],
                  title: item.title[0],
                });
              }
            });

            context.commit('setNewsitems', items);
          });
        })
        .catch((err: Error) => context.commit('setError', err));
    },
  },
  getters: {},
});
